import isEmpty from "lodash/isEmpty.js";

export class EntityReminderValue {
  constructor(date, data) {
    let value = null;
    const hasValue = data.positive > 0 || data.negative > 0;
    const hasEvents = !isEmpty(data.events);
    let list = [];

    if (hasValue) {
      value = {
        count: data.positive + data.negative,
        positive: data.positive,
        negative: data.negative,
      };

      list = [
        `Измерений сделано: ${value.count}`,
        `Отмечено положительно: ${value.positive}`,
        `Отмечено отрицательно: ${value.count - value.positive}`,
      ];

      if (hasEvents && data.events.count > 1) {
        list.push(`Всего задач: ${data.events.count}`);
        list.push(`Выполненных задач${data.events.completed || 0}`);
      }
    }

    this.date = date;
    this.eventsCount = hasEvents ? data.events.count : 0;
    this.value = value;
    this.list = list;
  }
}
